export default __webpack_public_path__ + "static/media/Nimbus.710b1d07.jpg";